import React from 'react';
import { BoxProps } from '@material-ui/core';
import BaseCard from '../BaseCard';
import Icon from '../Icon';
import { generateAssetTitle } from './utils/generateAssetTitle';
import { AvatarSize, IconSize } from '../../types';
import { AssetSummaryExternalIcon } from '@askporter/grieg-types';

interface AssetListCardProps {
  assetRef?: string;
  isLoading?: boolean;
  isFilterOption?: boolean;
  title?: string;
  uid?: string;
  postalCode?: string;
  assetType?: string;
  imagePath?: string;
  icon?: AssetSummaryExternalIcon;
  cardOnClick?: (uid: string) => void;
  isSmallDevice: boolean;
  sxCard?: BoxProps['sx'];
}

const AssetListCard: React.FC<AssetListCardProps> = ({
  assetRef,
  isLoading,
  isFilterOption,
  title,
  uid,
  postalCode,
  assetType,
  imagePath,
  icon,
  cardOnClick,
  isSmallDevice,
  sxCard,
}: AssetListCardProps) => {
  const avatarSize = isFilterOption ? AvatarSize.MD : isSmallDevice ? AvatarSize.MD : AvatarSize.LG;
  const iconSize = isFilterOption ? IconSize.LG : isSmallDevice ? IconSize.MD : IconSize.LG;

  return (
    <BaseCard
      dataTestIdPrefix={`${uid}-asset-list`}
      cardActionAreaOnClick={cardOnClick ? () => cardOnClick(uid) : undefined}
      oneToneAvatar={{
        imagePath: imagePath,
        avatarSize,
        iconSize,
        iconPath: icon?.iconPath,
        bgColour: icon?.iconColourMask,
        isLoading: isLoading,
      }}
      overline={isLoading ? '-' : assetRef}
      title={generateAssetTitle(title, postalCode)}
      isLoading={isLoading}
      isSelectOption={isFilterOption}
      chip={{
        text: assetType,
        icon: <Icon fullPath={icon?.iconPath} size={IconSize.SM} />,
      }}
      sxCard={sxCard}
    />
  );
};

export default AssetListCard;
